import React from "react";
import "./About.css";

const highlights = [
  {
    num: "40%",
    title: "Faster Operator Response",
    desc: "React TypeScript dashboard with WebSockets, SSE & Recharts across 50+ devices",
  },
  {
    num: "35%",
    title: "Faster Data Retrieval",
    desc: "Redis caching, composite indexing & JWT-RBAC for 50+ multi-department users",
  },
  {
    num: "10K+",
    title: "Messages / Second",
    desc: "Real-time EMS & PMU platform across 15+ substations at 99.9% availability",
  },
  {
    num: "60%",
    title: "Better Search Efficiency",
    desc: "NIDHI SSS Portal — advanced filters & bulk CSV exports with Laravel",
  },
];

function About() {
  return (
    <section id="about" className="about section-band">
      <div className="section-inner">
        <header className="section-header">
          <div className="section-label">About</div>
          <h2 className="section-title">
            Professional <em>Summary</em>
          </h2>
          <p className="section-subtitle">
            React Developer with 2+ years building real-time dashboards and scalable web applications.
          </p>
        </header>

        <div className="about__grid">
          <aside className="about__card ui-card reveal">
            <div className="about__avatar">KS</div>
            <h3 className="about__name">Kashish Shukla</h3>
            <p className="about__role">React Developer · 2+ Years</p>

            <ul className="about__meta">
              <li>
                <span className="meta-icon" aria-hidden="true">◎</span>
                <a href="tel:+917007849495">+91 70078 49495</a>
              </li>
              <li>
                <span className="meta-icon" aria-hidden="true">◎</span>
                <a href="mailto:kashish.shukla.8076@gmail.com">kashish.shukla.8076@gmail.com</a>
              </li>
              <li><span className="meta-icon" aria-hidden="true">◎</span> Kanpur, India</li>
              <li><span className="meta-icon" aria-hidden="true">◎</span> IIT Kanpur — Project Associate</li>
              <li><span className="meta-icon" aria-hidden="true">◎</span> B.Tech CSE — RMLAU (78%)</li>
              <li><span className="meta-icon" aria-hidden="true">◎</span> GATE CSE 2026 Qualified</li>
            </ul>

            <hr className="about__divider" />

            <div className="about__socials">
              {[
                { label: "LinkedIn", href: "https://www.linkedin.com/in/kashish-shukla-dev/" },
                { label: "GitHub", href: "https://github.com/Kashish-Shukla18" },
                { label: "GitLab", href: "https://gitlab.com/kashish.shukla.8076" },
              ].map(({ label, href }) => (
                <a key={label} href={href} target="_blank" rel="noreferrer" className="ui-chip ui-chip--link">
                  {label}
                </a>
              ))}
            </div>
          </aside>

          <div className="about__content">
            <p className="about__bio card-body reveal">
              <strong>React Developer</strong> with <strong>2+ years of experience</strong> building
              real-time dashboards and scalable web applications using{" "}
              <strong>React, TypeScript, Django, FastAPI,</strong> and <strong>PostgreSQL</strong>.
              Skilled in WebSockets, REST APIs, state management, and performance optimisation.
              Delivered production systems at <strong>IIT Kanpur</strong> supporting power grid
              monitoring and utility operations.
            </p>

            <p className="about__bio about__bio--secondary card-body reveal">
              I engineer event-driven pipelines with <strong>Kafka, Redis, and InfluxDB</strong>,
              build operator dashboards with <strong>Recharts and React Leaflet</strong>, and integrate{" "}
              <strong>GenAI / RAG</strong> systems with LangChain and vector databases. Strong
              fundamentals backed by <strong>GATE CSE 2026 qualification</strong>.
            </p>

            <div className="about__highlights">
              {highlights.map(({ num, title, desc }) => (
                <div key={title} className="highlight ui-card reveal">
                  <span className="highlight__num">{num}</span>
                  <div className="highlight__text">
                    <strong>{title}</strong>
                    <span>{desc}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;
